import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Esto sirve si estoy estudiando?',
  a: 'Sí, te da claridad práctica desde el inicio, ayudándote a entender cómo se aplica la teoría en situaciones reales.'
}, {
  q: '¿Funciona en Argentina?',
  a: 'Sí, está adaptado a la realidad local, protocolos y medicamentos más utilizados en el país.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No, podés empezar desde cero. El material está diseñado para llevarte de la mano desde lo más básico hasta la aplicación clínica.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés garantía total de 7 días. Si sentís que el material no es para ti, nos envías un correo y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-12 px-5 bg-brand-navy" data-id="element-100">
      <div className="max-w-xl mx-auto" data-id="element-101">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-102">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-103">
          {faqs.map((faq, idx) => <div key={idx} className="bg-brand-blue-dark/30 border border-white/5 rounded-xl overflow-hidden" data-id="element-104">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gray-800/50 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-105">
                <span className="font-bold text-white text-sm pr-4" data-id="element-106">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-yellow flex-shrink-0" size={18} data-id="element-107" /> : <ChevronDown className="text-gray-600 flex-shrink-0" size={18} data-id="element-108" />}
              </button>
              {openIdx === idx && <div className="px-5 pb-4 text-sm text-gray-400 leading-relaxed border-t border-gray-800" data-id="element-109">
                  <div className="pt-3" data-id="element-110">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}